import { render, staticRenderFns } from "./ChatECardFriendV2.vue?vue&type=template&id=47b942a0&scoped=true"
import script from "./ChatECardFriendV2.vue?vue&type=script&lang=js"
export * from "./ChatECardFriendV2.vue?vue&type=script&lang=js"
import style0 from "./ChatECardFriendV2.vue?vue&type=style&index=0&id=47b942a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b942a0",
  null
  
)

export default component.exports